module.exports = __webpack_public_path__ + "static/media/view4.b5dd5e40.jpg";